import api from './index';
const endpoints = {
    translate: '/admin/translate',
};
export const getTranslation = async (body) => {
    const res = await api.post(endpoints.translate, body);
    return res.data;
};
